import React from 'react';
import styled, { CSSObject } from 'styled-components';

type IconLinkVariant = 'white';

interface StyledIconLinkProps {
  variant?: IconLinkVariant;
}

const StyledIconLink = styled.a<StyledIconLinkProps>(({ variant, theme }) => {
  const baseStyle: CSSObject = {
    appearance: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '22px',
    height: '22px',
    border: 0,
    margin: 0,
    padding: 0,
    background: 'transparent',
    color: theme.colors.ciBlue3,
    cursor: 'pointer',
    transition: 'color 0.1s ease',
    svg: {
      width: '18px',
      maxWidth: 'none',
      height: '18px',
      verticalAlign: 'top',
    },
    '&:hover': {
      color: theme.colors.ciRed,
    },
    '&:active': {
      color: theme.colors.ciRed,
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'default',
      pointerEvents: 'none',
      '&:hover': {
        opacity: 0.5,
      },
    },
  };

  switch (variant) {
    case 'white':
      return {
        ...baseStyle,
        color: 'white',
        '&:hover': {
          color: theme.colors.ciBlue5,
        },
        '&:active': {
          color: 'white',
        },
      };

    default:
      return {
        ...baseStyle,
      };
  }
});

interface IconLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: IconLinkVariant;
  icon?: React.ReactNode;
}

const IconLink: React.FC<IconLinkProps> = ({ variant, icon, type, ...props }) => {
  return (
    <StyledIconLink variant={variant} {...props}>
      {icon}
    </StyledIconLink>
  );
};

export default IconLink;
